import { z } from "zod";

export const createPinSchema = z.object({
  pin_type: z.enum(["organization", "school", "sponsor", "team", "event"]),
  entity_type: z.enum(["Organization", "School", "Sponsor", "Team", "Event"]),
  entity_id: z.string().min(1, "Entity ID is required"),
});

export type CreatePinInput = z.infer<typeof createPinSchema>;
